import React, {useRef} from 'react';
import {OrganicMobileComponent} from './OrganicMobile.style';
import shape from '../../../../public/image/WhyUs/Organic/mobile/shape.webp';
import person from '../../../../public/image/WhyUs/Organic/mobile/person.webp';
import ball from '../../../../public/image/WhyUs/Organic/mobile/ball.webp';
import ball_background from '../../../../public/image/WhyUs/Organic/mobile/ball_background.webp';
import flag from '../../../../public/image/WhyUs/Organic/mobile/flag.webp';
import flag_background from '../../../../public/image/WhyUs/Organic/mobile/flag_background.webp';
import excalibur from '../../../../public/image/WhyUs/Organic/mobile/excalibur.webp';
import bg1 from '../../../../public/image/WhyUs/Organic/mobile/bg1.webp';
import bg2 from '../../../../public/image/WhyUs/Organic/mobile/bg2.webp';

const OrganicMobile = ({active}) => {
  const wrap = useRef();
  return (
    <OrganicMobileComponent secHeight={active ? wrap.current?.clientHeight : 0}>
      <div className='organic' ref={wrap}>
        <img
          src={bg1.src}
          alt=''
          className='organicmob__background organicmob__background--1'
        />
        <img
          src={bg2.src}
          alt=''
          className='organicmob__background organicmob__background--2'
        />
        <div className='organicmob__header'>
          <p className='organicmob__header--text'>
            Organic <br /> Scalability
          </p>
          <img src={shape.src} alt='' className='organicmob__header--img' />
        </div>
        <img
          src={person.src}
          alt=''
          className='organicmob__person organicmob__person--hidden'
        />
        <div className='organicmob__ball'>
          <img
            src={person.src}
            alt=''
            className='organicmob__person organicmob__person--visible'
          />

          <img
            src={ball_background.src}
            alt=''
            className='organicmob__ball--background'
          />
          <img src={ball.src} alt='' className='organicmob__ball--img' />
        </div>
        <div className='organicmob__demonstrate'>
          <p className='organicmob__demonstrate--header'>
            Demonstrated Efficacy
          </p>
          <p className='organicmob__demonstrate--content'>
            <span className='organicmob__demonstrate--content-blue'>
              {'"LMS"'}
            </span>{' '}
            provides an expansive in-house business model that demonstrated its
            efficacy across <span>14 departments</span> to meet the demands of
            the growing market and achieve an{' '}
            <span>integrated operational breadth for your business.</span>
          </p>
        </div>
        <div className='organicmob__ball organicmob__flag'>
          <img
            src={flag_background.src}
            alt=''
            className='organicmob__ball--background'
          />
          <img
            src={flag.src}
            alt=''
            className='organicmob__ball--img organicmob__flag--img'
          />
        </div>
        <div className='organicmob__demonstrate organicmob__insightful'>
          <p className='organicmob__demonstrate--header'>
            Insightful Decision-Making
          </p>
          <p className='organicmob__demonstrate--content organicmob__insightful--content'>
            Empower you <span>insightful decision-making</span> process through
            the standardized productivity metrics across all functions and
            detailed productivity optimization reports provided by our{' '}
            <span>EXCALIBUR SYSTEM</span> to increased productivity.
          </p>
          <img
            src={excalibur.src}
            alt=''
            className='organicmob__insightful--excalibur'
          />
          <p className='organicmob__demonstrate--content organicmob__insightful--content'>
            Our <span>EXCALIBUR SYSTEM</span> helps your business increased
            productivity and facilitates an insightful decision-making process
            by providing{' '}
            <span>
              <span className='organicmob__demonstrate--content-blue'>
                standardized productivity metrics across all functions &
                detailed productivity optimization reports.
              </span>
            </span>
          </p>
        </div>
      </div>
    </OrganicMobileComponent>
  );
};

export default OrganicMobile;
